const SET_QUERY_LENGTH_WARNING = 'app/search/SET_QUERY_LENGTH_WARNING';
const SET_SEARCH_PAGE = 'app/search/SET_SEARCH_PAGE';
const SET_SEARCH_QUERY = 'app/search/SET_SEARCH_QUERY';
const SET_SEARCH_FILTER = 'app/search/SET_SEARCH_FILTER';
const SET_SEARCH_SORT = 'app/search/SET_SEARCH_SORT';
const SET_SEARCH_STATUS = 'app/search/SET_SEARCH_STATUS';
const SET_SEARCH_SUMMARY = 'app/search/SET_SEARCH_SUMMARY';

export {
  SET_QUERY_LENGTH_WARNING,
  SET_SEARCH_SORT,
  SET_SEARCH_PAGE,
  SET_SEARCH_QUERY,
  SET_SEARCH_FILTER,
  SET_SEARCH_STATUS,
  SET_SEARCH_SUMMARY,
};
